export const ROLES = {
  STUDENT: 'student',
  TEACHER: 'teacher',
  TEACHING_ASSISTANT: 'teaching_assistant',
  COORDINATOR: 'coordinator',
  CONTENT_TEAM: 'content_team',
  RESEARCH_TEAM: 'research_team',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_LABELS: Record<Role, string> = {
  [ROLES.STUDENT]: 'Student',
  [ROLES.TEACHER]: 'Teacher',
  [ROLES.TEACHING_ASSISTANT]: 'Teaching Assistant',
  [ROLES.COORDINATOR]: 'Coordinator',
  [ROLES.CONTENT_TEAM]: 'Content Team',
  [ROLES.RESEARCH_TEAM]: 'Research Team',
  [ROLES.ADMIN]: 'Admin',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
};

export const PLATFORM_OPS_ROLES: Role[] = [ROLES.SUPER_ADMIN];

/** @deprecated Legacy broad admin list - use PLATFORM_OPS_ROLES for /admin routes. */
export const ADMIN_ROLES: Role[] = [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.COORDINATOR];
